import React, {useEffect, useState} from "react";
import api from "../../api";
import {useParams} from "react-router-dom";
import OrderOverview from "../../Components/OrderOverview";
import {Button, Col, Form, Row, message, Space, Alert} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {ArrowUpOutlined, CopyOutlined, CreditCardOutlined} from "@ant-design/icons";
import {DEFAULT_GUTTER} from "../../constants";

export default function CustomerOrderStatus() {
    const {order_id, secret} = useParams();
    const [order, setOrder] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);

    useEffect(() => {
        api.getOrder(order_id, secret).then(setOrder)
    }, []);

    const [form] = Form.useForm();

    const handlePayNow = async () => {
        setPaymentLoading(true);
        try {
            const response = await api.getOrderPaymentUrl(order_id, secret);
            // Redirect to Mollie payment page
            window.location.href = response.payment_url;
        } catch (error) {
            console.error('Error getting payment URL:', error);
            message.error('Fout bij het ophalen van de betaallink');
            setPaymentLoading(false);
        }
    };

    return (
        <div>
            {order && (
                <>

                    {order.status === 'pending' && (
                        <Alert style={{marginBottom: '1em'}} description={(
                            <>
                                <p>Let op! Deze bestelling is nog niet betaald.</p>
                                <Button
                                    type="primary"
                                    icon={<CreditCardOutlined/>}
                                    loading={paymentLoading}
                                    onClick={handlePayNow}
                                >
                                    Nu Betalen
                                </Button>
                            </>
                        )}></Alert>
                    )}

                    <OrderOverview order={order} isSeller={false}/>
                </>
            )}

            {order && (

                <Form layout={"vertical"} form={form}>
                    <Row gutter={DEFAULT_GUTTER}>
                        <Col span={22}>
                            <Form.Item label={"Stuur bericht naar de verkoper"} name={"message"}>
                                <TextArea/>
                            </Form.Item>
                        </Col>
                        <Col span={2}>
                            <Form.Item label={" "}>
                                <Button type={"primary"} onClick={() => {
                                    if (form.getFieldValue('message') === "") {
                                        return
                                    }
                                    api.messageSeller(order.id, order.secret, form.getFieldValue('message')).then(() => {
                                        message.success("Bericht is verstuurd naar verkoper!");
                                        form.resetFields();
                                        api.getOrder(order_id, secret).then(setOrder)
                                    }).catch(() => {
                                        message.error("Er is een fout opgetreden bij het versturen van het bericht.");
                                    });
                                }}><ArrowUpOutlined/> Verstuur</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </div>
    );
}